





















































































































import Vue from 'vue';

import Header from '@/components/Header';
import { QueryFunctions, _loadComponent } from './services/helper';

import AdminModal from '@/components/Modals/AdminModal.vue';
import LocaleSwitcherModal from '@/components/Modals/LocaleSwitcherModal.vue';

export default Vue.extend({
  components: {
    Header,
    AdminModal,
    LocaleSwitcherModal,
    CandidateDetailsModal: (resolve) => _loadComponent('Modals/CandidateDetailsModal/', resolve),
  },
  data() {
    return {
      Client: process.env.VUE_APP_CLIENT,
    };
  },
  mounted() {
    if (Object.keys(this.$route.query).length > 0) {
      const route = QueryFunctions.copyRoute(this.$route);
      this.$router.replace(route);
    }
  },
});
